import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import Barcode from 'react-barcode';

import { ITsaScreener } from '../../../globals/interfaces';
import BackButton from '../../../components/custom/BackButton';
import { Label } from 'reactstrap';
import { createdUpdatedInfo, notify } from '../../../utils';
import ActionIcon from '../../../components/custom/ActionIcon';
import { print } from '../../../utils';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedScreener: ITsaScreener | undefined;
    deleteScreener: (id: number) => Promise<boolean>;
}

export default function ModalViewScreener ({
    modal,
    setModal,
    selectedScreener,
    deleteScreener
}: Props) {

    const toggle = () => setModal(!modal);
    const handleDeleteScreener = () => {
        if (!selectedScreener) return;
        deleteScreener(selectedScreener.id);
        toggle();
        notify('Screener Removed');
    }

    const printBarcode = () => {
        if (!selectedScreener) return;
        const printDiv = <div dangerouslySetInnerHTML={{__html: `
            <html>
                <head>
                    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">
                </head>
                <body>
                    <style>
                        @media print {

                            @page {                
                                size: A4;
                                margin: 0mm;
                            }

                            html, body, .row {
                                width: 1024px;
                            }

                            body {
                                margin: 0 auto;
                            }

                            .barcode {
                                width: 200px;
                                height: auto;
                            }

                            .screener-container {
                                text-align: center;
                            }

                        }
                    </style>
                    <div class='container-fluid' style='margin-top: 20px'>
                        <div>
                            <div class="screener-container">
                                <h3>TSA SCREENER</h3>
                                <h4>${selectedScreener.name}</h4>
                                <img src="https://www.barcode.graphics/wp-content/uploads/2015/03/GS1-128-14-101.png" class="barcode" />    
                            </div>
                        </div>
                    </div>
                    <script>
                        setTimeout(() => {
                            window.print();
                        }, 1000);
                    </script>
                </body>
            </html>
        `}}></div>
        print(printDiv);
    }

    if (!selectedScreener) return null;

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>View Screener: {selectedScreener.name}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody className={'text-center'}>
                <Barcode 
                    value={selectedScreener.barcodeNumber}
                    format={'CODE128'}
                    width={1}
                />
                <h4 className={'mt-2'}>PIN: {selectedScreener.pin}</h4>
            </ModalBody>
            <ExpandedFooter>
                <Label>
                    {createdUpdatedInfo(selectedScreener, true)}
                </Label>
                <FooterContentContainer>
                    <ActionIcon 
                        type={'delete'} 
                        onClick={() => handleDeleteScreener()} 
                    />
                    <ActionIcon type={'print'} onClick={() => printBarcode()} />
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
`;

const FooterContentContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;